import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { Subscription, Subject } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { VacanciesService } from '../../../core/vacancy/vacancies.service';
import { LayoutUtilsService, MessageType } from '../../../core/_base/crud/utils/layout-utils.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'kt-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.scss']
})
export class AuditTrailComponent implements OnInit, OnDestroy {
  // Filter models
  searchKey: string = '';
  descriptionFilter: string = '';
  startDate: string = '';
  endDate: string = '';
  
  exportData: any[] = [];
  listData: MatTableDataSource<any> = new MatTableDataSource();
  displayedColumns = ['action', 'description', 'module', 'actor', 'type', 'dateCreated'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('sort1', { static: true }) sort: MatSort;
  
  private unsubscribe$ = new Subject<void>();

  constructor(
    private vacancyService: VacanciesService,
    private layoutUtilsService: LayoutUtilsService
  ) { }

  ngOnInit() {
    this.getAudit();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  /**
   * Fetch Audit Logs with filters
   * Note: This assumes your getAudits() service method now accepts these params
   */
  getAudit() {
    // We pass page (0-indexed for backend from_record_num) and limit
    const page = this.paginator ? this.paginator.pageIndex + 1 : 1;
    const limit = this.paginator.pageSize ? this.paginator.pageSize : 50;

    this.vacancyService.getAudits(
      page, 
      limit, 
      this.searchKey, 
      this.descriptionFilter, 
      this.startDate, 
      this.endDate
    ).pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
      // Assuming res is the array of records from the PHP API
      const data = res || [];
      this.exportData = data;
      this.listData = new MatTableDataSource(data);
      
      // For server-side, we don't link paginator directly to listData
      // but we use the backend results
      this.listData.sort = this.sort;
    }, err => {
      this.layoutUtilsService.showActionNotification("Error fetching logs", MessageType.Read);
    });
  }

  /**
   * Triggered on keyup/change
   */
  applyFilter() {
    // Reset to first page when filtering
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.getAudit();
  }

  clearFilters() {
    this.searchKey = '';
    this.descriptionFilter = '';
    this.startDate = '';
    this.endDate = '';
    this.getAudit();
  }

  exportExcel() {
    const workSheet = XLSX.utils.json_to_sheet(this.exportData);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Audit_Logs');
    XLSX.writeFile(workBook, `Audit_Trail_${Date.now()}.xlsx`);
  }
}